import { z } from "zod";

export const OnboardingDCBoxItemSchema = z.object({
  Completed: z.boolean().optional(),
  Available: z.boolean().optional(),
  DeliveryCompleted: z.boolean().optional(),
  DeliveryStatus: z.string().optional(),
  TrackingNumber: z.string().optional(),
  TrackingLink: z.string().optional().optional(),
  Activated: z.boolean().optional(),
  BusinessUnitProductId: z.string().optional(),
});

export type OnboardingDCBoxItemType = z.infer<typeof OnboardingDCBoxItemSchema>;
